import { LeanDocument, MakeOptional, Types } from "../types/_utils.types";

export enum Resource {
  APPLICATION = "application",
  LOAN = "loan",
  // LAWSUIT = "lawsuit",
}

export enum LifeCycle {
  /** Default entrypoint of all resources */
  ENTRY = "entry",
  /** Non Terminal Stages */
  INTERMEDIATE = "intermediate",
  /** Can not be moved by system triggers, must be manual */
  STALLED = "stalled",
  /** Final stage, can not move after this */
  EXIT = "exit",
}

export type Stage = {
  resource: Resource;
  owner: Types.ObjectId;
  lifecycle: LifeCycle;
  /** Unique per owner */
  value: string;
  label: string;
  icon: string;
  color: string;
  /** Only works for custom stages */
  archived: boolean;
  /** System Generated */
  locked: boolean;
  /** Others can see but can not use */
  public: boolean;
  /** True when in use, false by default */
  used: boolean;
  external: boolean;
  meta: Record<string, any>;
};

export type StageDto = LeanDocument<Stage>;
export type CreateStage = Pick<Stage, "label" | "value" | "lifecycle" | "icon" | "color" | "public" | "resource">;
export type UpdateStage = Partial<Omit<CreateStage, "value" | "resource"> & Pick<Stage, "archived">>;

export namespace Stage {
  export type Dto = StageDto;
  export type Create = CreateStage;
  export type Update = UpdateStage;
}

export default Stage;
